export default {
  // Words
  areYouSureToRemoveThisFile: 'آیا از حذف این فایل اطمینان دارید؟',
  chooseFile: 'انتخاب فایل',
  file_extension_not_accepted: 'نوع فایل "{fileName}" پذیرفته نیست. نوع های قابل پذیرش "{accepted}" است.',
  file_max_size_exceeded: 'حجم فایل "{fileName}" بیشتر از حد مجاز است. فایل هایی با حجمی کمتر از {maxSize} کیلو بایت آپلود کنید.',
  filesNumberExceedsTheLimit: 'تعداد فایل ها باید حداکثر {max} عدد باشد',
  gregorianCal: 'تقویم میلادی',
  hasError: 'خطای اعتبارسنجی!',
  jalaliCal: 'تقویم شمسی',
  lastWeekDay: 'dddd [گذشته]',
  today: 'امروز',
  tomorrow: 'فردا',
  uploading: 'در حال آپلود',
  yesterday: 'دیروز'
}
